module.exports = __webpack_public_path__ + "static/mimo-d6f529c39b3d9b4ae6ceddcf0e6b1da2.jpg";